export class OffCanvas {
    constructor() {
        this.offCanvas = document.querySelector('[data-js-off-canvas]');

        if (this.offCanvas) {
            this.initOpenAction();
            this.initCloseAction();
            this.initSubmenus();
            this.checkActiveLinks();
        }
    }

    initOpenAction() {
        document.querySelector('[data-js-off-canvas-open]')?.addEventListener('click', (e) => {
            e.preventDefault();
            this.open();
        });
    }

    initCloseAction() {
        document.querySelector('[data-js-off-canvas-close]')?.addEventListener('click', (e) => {
            e.preventDefault();
            this.close();

        });
        window.addEventListener('keydown', (e) => {
            if (this.offCanvas.classList.contains('c-off-canvas--visible') && e.key === 'Escape') {
                this.close();
            }
        });
    }

    open() {
        this.offCanvas.classList.remove('c-off-canvas--hidden');
        this.offCanvas.classList.add('c-off-canvas--visible');
        this.offCanvas.querySelector('[data-js-off-canvas-close]')?.focus();
    }

    close() {
        this.offCanvas.classList.remove('c-off-canvas--visible');
        setTimeout(() => {
            this.offCanvas.classList.add('c-off-canvas--hidden');
        }, 150)
        document.querySelector('[data-js-off-canvas-open]')?.focus();
    }

    initSubmenus() {
        document.querySelectorAll('[data-js-off-canvas-submenu]').forEach(submenu => {
            if (submenu) {
                submenu.querySelector('[data-js-off-canvas-submenu-toggle]')?.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.toggleSubmenu(submenu);
                })
                submenu.querySelector('[data-js-off-canvas-submenu-toggle]')?.addEventListener('mousedown', (e) => {
                    e.preventDefault();
                })
                submenu.querySelector('[data-js-off-canvas-submenu-toggle]')?.addEventListener('focus', (e) => {
                    e.preventDefault();
                    this.toggleSubmenu(submenu);
                })
            }
        });
    }

    checkActiveLinks() {
        document.querySelectorAll('[data-js-off-canvas-submenu]').forEach(submenu => {
            if (submenu && submenu.querySelector('.active')) {
                this.toggleSubmenu(submenu);
            }
        });
    }

    toggleSubmenu(submenu) {
        submenu.classList.toggle('c-off-canvas__link--collapsed');
    }
}